import { Outlet, useMatchRoute, useParams } from '@tanstack/react-router';
import { useUserPermissions } from '@anytag/auth';
import { AgencyWithAdvertisers, useAgencyQuery } from '@anytag/graphql';
import { ButtonLink, RenderDataWithFallback } from '@anytag/shared-atoms';
import { useQueryHelper } from '@anytag/shared-hooks';
import { Header } from '@anytag/shared-molecules';
import { AgencyTabs } from '@anytag/shared-organisms';
import { AgencyDetailsProvider } from './agency-details-context';

export const AgencyDetails = () => {
  const { t, navigate, enqueueSnackbar } = useQueryHelper();
  const params = useParams({ from: '/_private-routes/agency/$id' });
  const { hideAddUserBtn } = useUserPermissions();
  const matchRoute = useMatchRoute();
  const { data, loading } = useAgencyQuery({
    fetchPolicy: 'network-only',
    variables: { pk: Number(params.id) },
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
      navigate({ to: '/agency' });
    }
  });
  const hasAddUserLink = !hideAddUserBtn && !!matchRoute({ to: '/agency/$id/users' });
  const agency = data?.agency;

  return (
    <RenderDataWithFallback loading={loading} hasNoData={!agency}>
      <AgencyDetailsProvider values={{ agency: agency as AgencyWithAdvertisers }}>
        <div>
          <Header>
            {hasAddUserLink ? (
              <ButtonLink
                to="/user/add"
                variant="solid"
                title={t('Button.Add User')}
                className="ml-auto min-w-27 capitalize"
                prefixIcon={{ icon: 'plus', size: '10px' }}
              />
            ) : null}
          </Header>

          <div>
            <AgencyTabs agencyId={Number(agency?.id)} />
            <Outlet />
          </div>
        </div>
      </AgencyDetailsProvider>
    </RenderDataWithFallback>
  );
};
